import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMediaDropdownOpen, setIsMediaDropdownOpen] = useState(false);
  const [isAdminDropdownOpen, setIsAdminDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
      setIsMediaDropdownOpen(false);
      setIsAdminDropdownOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/8c75b34306599e28cafd501142ec58d6/6544712b4051e0bdfd79201f42094c9a.png" 
              alt="Kingdom Bridge Mission Logo" 
              className="h-12 w-auto"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6">
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
            >
              단체 소개
            </button>
            <button 
              onClick={() => scrollToSection('ministries')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
            >
              주요 사역
            </button>
            
            {/* KBM Media Dropdown */}
            <div className="relative">
              <button 
                onClick={() => setIsMediaDropdownOpen(!isMediaDropdownOpen)}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
              >
                KBM Media
                <i className={`ri-arrow-down-s-line ml-1 transition-transform ${isMediaDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {isMediaDropdownOpen && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-50">
                  <button 
                    onClick={() => scrollToSection('field-reporting')}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                  >
                    Field Reporting
                  </button>
                  <button 
                    onClick={() => scrollToSection('field-news')}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                  >
                    Field News
                  </button>
                  <button 
                    onClick={() => scrollToSection('kbm-insights')}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                  >
                    Monthly Mission
                  </button>
                  <button 
                    onClick={() => scrollToSection('kbm-insights')}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                  >
                    KBM Insights
                  </button>
                </div>
              )}
            </div>

            <button 
              onClick={() => scrollToSection('support-method')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
            >
              후원방법
            </button>
            
            {/* Admin Dropdown */}
            <div className="relative">
              <button 
                onClick={() => setIsAdminDropdownOpen(!isAdminDropdownOpen)}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
              >
                <i className="ri-settings-3-line mr-1"></i>
                관리자
                <i className={`ri-arrow-down-s-line ml-1 transition-transform ${isAdminDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {isAdminDropdownOpen && (
                <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-50">
                  <Link 
                    to="/admin/prayer"
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                    onClick={() => setIsAdminDropdownOpen(false)}
                  >
                    수요910 기도
                  </Link>
                  <Link 
                    to="/admin/field-reporting"
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                    onClick={() => setIsAdminDropdownOpen(false)}
                  >
                    Field Reporting
                  </Link>
                  <Link
                    to="/admin/field-news"
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                    onClick={() => setIsAdminDropdownOpen(false)}
                  >
                    Field News
                  </Link>
                  <Link
                    to="/admin/kbm-insights"
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                    onClick={() => setIsAdminDropdownOpen(false)}
                  >
                    KBM Insights
                  </Link>
                  <Link
                    to="/admin/mission-fields"
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                    onClick={() => setIsAdminDropdownOpen(false)}
                  >
                    후원 사역 현장
                  </Link>
                  <Link
                    to="/admin/partner-churches"
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
                    onClick={() => setIsAdminDropdownOpen(false)}
                  >
                    협력교회 및 협력선교지
                  </Link>
                </div>
              )}
            </div>

            <button 
              onClick={() => scrollToSection('support-participation')}
              className={`px-6 py-2.5 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'bg-[#2F4F4F] text-white hover:bg-[#1F3F3F]' : 'bg-[#D4AF37] text-[#2F4F4F] hover:bg-[#C49F27]'}`}
            >
              후원 및 참여
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 cursor-pointer"
          >
            <div className={`w-6 h-6 flex items-center justify-center ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              <i className={`ri-menu-line text-2xl`}></i>
            </div>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 bg-white rounded-lg shadow-lg">
            <button 
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-6 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
            >
              단체 소개
            </button>
            <button 
              onClick={() => scrollToSection('ministries')}
              className="block w-full text-left px-6 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
            >
              주요 사역
            </button>
            <button 
              onClick={() => scrollToSection('field-reporting')}
              className="block w-full text-left px-6 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
            >
              Field Reporting
            </button>
            <button 
              onClick={() => scrollToSection('field-news')}
              className="block w-full text-left px-6 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
            >
              Field News
            </button>
            <button 
              onClick={() => scrollToSection('kbm-insights')}
              className="block w-full text-left px-6 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
            >
              Monthly Mission & KBM Insights
            </button>
            <button 
              onClick={() => scrollToSection('support-method')}
              className="block w-full text-left px-6 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
            >
              후원방법
            </button>
            <div className="px-6 py-2 text-xs font-semibold text-gray-500">관리자</div>
            <Link 
              to="/admin/prayer"
              className="block w-full text-left px-6 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              수요910 기도
            </Link>
            <Link 
              to="/admin/field-reporting"
              className="block w-full text-left px-6 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Field Reporting
            </Link>
            <Link
              to="/admin/field-news"
              className="block w-full text-left px-6 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Field News
            </Link>
            <Link
              to="/admin/kbm-insights"
              className="block w-full text-left px-6 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              KBM Insights
            </Link>
            <Link
              to="/admin/mission-fields"
              className="block w-full text-left px-6 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              후원 사역 현장
            </Link>
            <Link
              to="/admin/partner-churches"
              className="block w-full text-left px-6 py-2 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              협력교회 및 협력선교지
            </Link>
            <button 
              onClick={() => scrollToSection('support-participation')}
              className="block w-full text-left px-6 py-3 text-sm font-medium text-[#2F4F4F] hover:bg-gray-50 cursor-pointer mt-2"
            >
              후원 및 참여
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
